import { Injectable } from '@angular/core';
import { JobPipelineHealth } from '../core-data-model/Job/JobPipelineHealth.model';
import { Job } from '../core-data-model/Job.model';
import { AssociatedPersonInformationServer } from '../core-data-model/JobInformation.interface';
import { Person } from '../core-data-model/Person.model';
import {
    PeopleAndJobsServerEntry,
    PeopleAndJobsJobServer
} from '../core-data-model/SearchApi.serverinterface';
import { FoldersDataService } from '../core-services/Folders.dataservice';
import { JobTransformers } from '../core-services/JobApi.datatransform';
import { JobPipelineTransformers } from '../core-services/JobPipeline.datatransform';
import { PersonApiTransformer } from '../core-services/PersonApi.datatransform';
import { Util } from '../core-utilities/Util';

@Injectable({
    providedIn: 'root'
})
export class SearchTransformers {
    constructor(
        private util: Util,
        private jobTransformers: JobTransformers,
        private personTransformers: PersonApiTransformer,
        private jobPipelineTransformers: JobPipelineTransformers,
        private foldersService: FoldersDataService
    ) {}

    transformPeopleAndJobs(
        searchResultJSON: PeopleAndJobsServerEntry
    ): Person | Job {
        let output;
        if (searchResultJSON.isPerson) {
            output = this.personTransformers.transformPerson(searchResultJSON);
        } else if (searchResultJSON.isPerson === false) {
            output = this.transformJob(searchResultJSON);
        }
        return output;
    }

    private transformPipelineHealth(
        jobId: string,
        associatedPeople: AssociatedPersonInformationServer[]
    ): JobPipelineHealth {
        return this.jobPipelineTransformers.transformPipelineHealth(
            jobId,
            associatedPeople
        );
    }

    private transformJob(searchResultJSON: PeopleAndJobsJobServer): Job {
        const jobJSON = searchResultJSON.jobInformation;
        return new Job({
            lastUpdated: this.util.newDate(searchResultJSON.sortDate),
            title: jobJSON.name,
            id: jobJSON.id,
            behavioralRanges: this.jobTransformers.transformBehavioralJobScore(
                jobJSON.patternScoringInformationInSigma
            ),
            cognitiveTarget: jobJSON.cognitiveTarget,
            // TODO: the peopleandjobs call *should* also return the job's cognitiveWeight
            folder: this.foldersService.getFolder(searchResultJSON.folderId),
            jobPipeline: this.transformPipelineHealth(
                jobJSON.id,
                jobJSON.associatedPeopleInformation || []
            ),
            createdDate: this.util.newDate(searchResultJSON.createdTime),
            lastModifiedBy: jobJSON.modifiedById
        });
    }
}
